<script>
    import { onDestroy } from 'svelte';
    import { Col, Container, Row } from 'sveltestrap';
    import { Spinner, Toast, ToastHeader, ToastBody } from 'sveltestrap';

    export let server;
    export let token;
    export let login;
    export let password;
    export let func;
    export let operation;
    export let node;
    export let refresh;

    let savedMedia = {};
    let retryFunction = 0;
    let retryImage = 0;
    let status = "danger";
    let statusText = "";
    let refreshInterval;
    let refreshImageInterval;
    let playlist = [];

    function getMediaName(filename) {
        const mediaId = filename.split('.')[0];
        if (typeof(savedMedia[mediaId]) != 'undefined')
            return savedMedia[mediaId].name;
        return filename;
    }

	async function getMediaList() {
        const response = await fetch(server + "/rest/media?block=is.null&smart=is.null&select=media_id,name", {
            method: 'GET',
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': "Bearer " + token
            }
		});
		const json = await response.json();

		if (response.ok) {
            savedMedia = {};
            json.forEach(element => savedMedia[element.media_id] = element);
			return json;
		} else {
			throw new Error(response.status);
		}
	}

    async function getPlaylist() {
        const response = await fetch(server + "/repository/operation-" + operation + ".list?_=" + 
            Math.floor(Math.random() * 10000000), {
            method: 'GET',
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': "Basic " + btoa(login + ":" + password)
            }
		});
		const text = await response.text();

		if (response.ok) {
			let rows = text.split("\n");
            playlist = rows.map(getMediaName);
		} else {
			throw new Error(response.status);
		}
    }

	async function getFunction(retry) {
        const response = await fetch(server + "/xco/rest/functions/" + func, {
            method: 'GET',
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': "Basic " + btoa("readonly:" + password)
            }
		});
		const json = await response.json();

		if (response.ok) {
			return json;
		} else {
			throw new Error(response.status);
		}
	}

    async function getImage(retry) {
        return new Promise((resolve, reject) => {
            let image = new Image();
            image.onload = () => resolve(image);
            image.onerror = reject;
            image.style = "margin-left: auto; margin-right:auto; display: block; width: 360px;";
            image.src = server + "/xco/scripts/get_snap.pl?community=" + password + "&row=" + node + "&filename=snap.jpeg&_=" + retry;
        });
    }

    Number.prototype.toFixed02 = function (r) {
        var pad = "";
        var i = this.toFixed(0);
        while ((pad + i).length < 2)
            pad += "0";
        return pad + this.toFixed(r);
    };

    function hrOffset(dur) {
        var h = "00", m = "00", s = "00";
        var i;

        i = Math.floor(dur / 3600);
        if (i >= 1) {
            h = i.toFixed02(0);
            dur -= i * 3600;
        }

        i = Math.floor(dur / 60);
        if (i >= 1) {
            m = i.toFixed02(0);
            dur -= i * 60;
        }

        i = dur;
        s = i.toFixed02(0);

        return h + ":" + m + ":" + s;
    }

    function getOffset(lastChange) {
        let date = new Date();
        let offset = Math.round(date.getTime() / 1000 - lastChange);
        return hrOffset(offset);
    }

    getMediaList().then(() => {
        retryFunction++;
        retryImage++;

        refreshInterval = setInterval(() => {
            retryFunction++;
        }, 1000);

        refreshImageInterval = setInterval(() => {
            retryImage++;
        }, refresh);

        getPlaylist();
    }, (error) => {
        status = "danger";
        statusText = "Error " + error.message;
    });

    onDestroy(() => {
        clearInterval(refreshInterval);
        clearInterval(refreshImageInterval);
    });

    $: if (retryFunction)
        getFunction(retryFunction).then((func) => {
            if (func.functionOpStatus == 1) {
                status = "success";
                statusText = "Playing " + getMediaName(func.functionPlayoutFilename) +
                            " at " + getOffset(func.functionPlayoutLastChange);
            } else {
                status = "danger";
                statusText = "Not playing";
            }
        }, (error) => {
            status = "danger";
            statusText = "Error " + error.message;
        });

    $: if (retryImage)
        getImage(retryImage).then((image) => {
            let element = document.getElementsByClassName("snapshot")[0];
            if (!element)
                return;
            element.innerHTML = "";
            element.appendChild(image);
        }, (error) => {
            let element = document.getElementsByClassName("snapshot")[0];
            if (!element)
                return;
            element.innerHTML = "Couldn't download snapshot (" + error.message + ")";
        });

        document.title = "[" + login + "] Status";
</script>

<div class="status"><Container><Row>
    <Col><div class="status"><Toast header={false}>
        <ToastHeader>Current playlist</ToastHeader>
        <ToastBody>
            {#each playlist as name}
                {name}<br>
            {/each}
        </ToastBody>
    </Toast></div></Col>

    <Col><div class="status"><Toast header={false}>
        <ToastHeader icon={status}>
            {#if !statusText}
                <Spinner primary size="sm" />
            {:else}
                {statusText}
            {/if}
        </ToastHeader>
        <ToastBody>
            <div class="snapshot" />
        </ToastBody>
    </Toast></div></Col>
</Row></Container></div>

<style>
    .status > :global(*) {
        width: 100%;
        max-width: 100%;
    }
</style>